import andiAvatar from "../../../../images/calcomProfilePics/andi.png";
import ninaAvatar from "../../../../images/calcomProfilePics/nina.png";
import zsofiAvatar from "../../../../images/calcomProfilePics/zsofi.png";
import i18n from "../../../../utils/i18n.js";
import classes from "./contactExpertCta.module.scss";

const TEAM_AVATARS = [
  { src: zsofiAvatar, alt: "Zsofi", layer: 1 },
  { src: ninaAvatar, alt: "Nina", layer: 2 },
  { src: andiAvatar, alt: "Andi", layer: 3 },
];

const ContactExpertCta = () => {
  return (
    <section className={classes.root} aria-label={i18n.t("searchflow.finalizeofferlabel")}>
      <div className={classes.avatars} aria-hidden="true">
        {TEAM_AVATARS.map((avatar) => (
          <img
            key={avatar.alt}
            src={avatar.src}
            alt=""
            className={classes.avatar}
            style={{ zIndex: avatar.layer }}
          />
        ))}
      </div>

      <h2 className={classes.title}>{i18n.t("searchflow.experttitle")}</h2>
      <p className={classes.text}>{i18n.t("searchflow.experttext")}</p>
    </section>
  );
};

export default ContactExpertCta;
